import routes from '../../config/routes'
import {Map} from 'immutable';

const queryRoutesToMap = (routes) => {
    let obj = {};
    routes[routes.length - 1].routes.map(item => {
        obj[item.key] = item
    })
    const objMap = Map(obj)
    return objMap
}

export const routesMap = queryRoutesToMap(routes)